/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TapeJobSource,
    TapeJobSourceFromJSON,
    TapeJobSourceFromJSONTyped,
    TapeJobSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ArchiveEndpointRequest
 */
export interface ArchiveEndpointRequest {
    /**
     * 
     * @type {Array<TapeJobSource>}
     * @memberof ArchiveEndpointRequest
     */
    source: Array<TapeJobSource>;
    /**
     * 
     * @type {Date}
     * @memberof ArchiveEndpointRequest
     */
    startDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ArchiveEndpointRequest
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ArchiveEndpointRequest
     */
    group?: number;
    /**
     * 
     * @type {number}
     * @memberof ArchiveEndpointRequest
     */
    group2?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArchiveEndpointRequest
     */
    _export?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArchiveEndpointRequest
     */
    export2?: boolean | null;
}

export function ArchiveEndpointRequestFromJSON(json: any): ArchiveEndpointRequest {
    return ArchiveEndpointRequestFromJSONTyped(json, false);
}

export function ArchiveEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArchiveEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source': ((json['source'] as Array<any>).map(TapeJobSourceFromJSON)),
        'startDate': (new Date(json['start_date'])),
        'name': json['name'],
        'group': !exists(json, 'group') ? undefined : json['group'],
        'group2': !exists(json, 'group2') ? undefined : json['group2'],
        '_export': !exists(json, 'export') ? undefined : json['export'],
        'export2': !exists(json, 'export2') ? undefined : json['export2'],
    };
}

export function ArchiveEndpointRequestToJSON(value?: ArchiveEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source': ((value.source as Array<any>).map(TapeJobSourceToJSON)),
        'start_date': (value.startDate.toISOString()),
        'name': value.name,
        'group': value.group,
        'group2': value.group2,
        'export': value._export,
        'export2': value.export2,
    };
}


